<template>
  <div class="newsletter">
    <h1>Nyhedsbrev</h1>
    <b-tabs class="mt-4" content-class="mt-3" lazy>
      <b-tab title="Skriv nyhedsbrev" :active="activeTab === 'newsletter'" @click="activeTab = 'newsletter'">
        <compose-newsletter></compose-newsletter>
      </b-tab>
      <b-tab title="Arkiv" :active="activeTab === 'archive'" @click="activeTab = 'archive'">
        <archive></archive>
      </b-tab>
      <b-tab title="Modtagere" :active="activeTab === 'recipients'" @click="activeTab = 'recipients'">
        <recipients></recipients>
      </b-tab>
      <b-tab title="Skabeloner" :active="activeTab === 'templates'" @click="activeTab = 'templates'">
        <templates></templates>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import ComposeNewsletter from '@/components/admin/ComposeNewsletter.vue'
import Archive from '@/components/admin/Archive.vue'
import Recipients from '@/components/admin/Recipients.vue'
import Templates from '@/components/admin/Templates.vue'
export default {
  name: 'Newsletter',
  components: { 
    ComposeNewsletter,
    Archive,
    Recipients,
    Templates
  },
  data: () => ({
    activeTab: 'newsletter',
  }),
  mounted() {
    this.$route.params.tab ? this.activeTab = this.$route.params.tab : null
    if (this.$route.query && this.$route.query.tab) {
      this.activeTab = this.$route.query.tab
    }
  },
  watch: {
    activeTab: function () {
      if (this.activeTab !== 'newsletter') {
        this.$router.push({ query: { tab: this.activeTab }}).catch(() => {})
      } else {
        this.$router.push({ query: {}}).catch(() => {})
      }
    }
  }
}
</script>

<style>

</style>